import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useURLSearchParams } from 'utils/hooks';

// There's a lot more we can do with this:
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md

function ScrollToTop({ children }) {
    const { pathname } = useLocation();
    const searchParams = useURLSearchParams();
    const country = searchParams.get('country');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname, country]);

    return children || null;
}

export default ScrollToTop;
